import { useContext } from 'react';
import { SessionCtx } from './SessionProvider';

export function useSession() {
  const ctx = useContext(SessionCtx);
  if (!ctx) throw new Error('useSession must be used inside <SessionProvider>');
  return ctx;
}
